customElements.get("accordions-custom") ||
  customElements.define(
    "accordions-custom",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.accordions = this.querySelectorAll(".accordion")),
          this.initAccordions();
      }
      initAccordions() {
        this.accordions.forEach((c) => {
          const o = c.querySelector(".accordion__intro"),
            t = c.querySelector(".accordion__content");
          c.classList.contains("accordion__active") && this.openAccordion(c),
            o.addEventListener("click", () => {
              if (window.location.href.includes("/products/")) {
                t.style.maxHeight && t.style.length > 0
                  ? this.closeAccordion(c)
                  : this.openAccordion(c);
              } else {
                t.style.maxHeight && t.style.length > 0
                  ? this.closeAccordion(c)
                  : (this.accordions.forEach((c) => this.closeAccordion(c)),
                    this.openAccordion(c));
              }
            });
        });
      }
      openAccordion(c) {
        const o = c.querySelector(".accordion__content");
        c.classList.add("accordion__active"),
          (o.style.maxHeight = "fit-content");
      }
      closeAccordion(c) {
        const o = c.querySelector(".accordion__content");
        c.classList.remove("accordion__active"), (o.style.maxHeight = null);
      }
    }
  );
